import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import Gettext from '@indeed/indeed-gettext';
import type { AutoApplyClientData } from './ssrData';
import App from './App';
import { createApolloClient } from './lib/apollo/client';
import { initializeDatadogRum } from './lib/rum/datadogRum';
import { createClientEventLogger } from './lib/eventLogger/eventLogger.client';
import { validateSSRData } from './lib/validateSSRData';

const ssrData: AutoApplyClientData | undefined = window.__AUTO_APPLY_DATA__;
validateSSRData(ssrData);

const { initialState, localeData } = ssrData;

const gt = Gettext((localeData || { '': {} }) as Parameters<typeof Gettext>[0]);

if (initialState.rumConfig) {
    initializeDatadogRum({
        ...initialState.rumConfig,
        graphqlEndpoint: initialState.graphqlEndpoint,
    });
}

const eventLogger = createClientEventLogger(initialState.setupLogUid, initialState.reviewLogUid);

const apolloClient = createApolloClient(ssrData.apolloState, initialState, eventLogger);

if (process.env.NODE_ENV === 'development') {
    window.__APOLLO_CLIENT__ = apolloClient;
}

const container = document.getElementById('app-root');
if (!container) {
    throw new Error('Could not find #app-root element for hydration');
}

hydrateRoot(
    container,
    <App
        initialState={initialState}
        apolloClient={apolloClient}
        gt={gt}
        Router={BrowserRouter}
        eventLogger={eventLogger}
    />,
);
